import React, { useContext } from 'react'

import SidebarContent from './SidebarContent'
import { Transition } from '@windmill/react-ui'

import { SidebarContext } from '../../context/SidebarContext'
import ServerIP from '../../utils/serverIp'

function MobileSidebar() {
  const { isSidebarOpen, closeSidebar } = useContext(SidebarContext)

  return (
    <Transition show={isSidebarOpen}>
      <>
        {/* <Transition
          enter="transition ease-in-out duration-150"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition ease-in-out duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <button className='bg-black' onClick={closeSidebar} >aa</button>
        </Transition> */}

        <Transition
          enter="transition ease-in-out duration-150"
          enterFrom="opacity-0 transform -translate-x-20"
          enterTo="opacity-100"
          leave="transition ease-in-out duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0 transform -translate-x-20"
        >
          <aside className="fixed inset-y-0 z-50 flex-shrink-0 w-64 mt-16 flex flex-col overflow-y-auto bg-side_bar_bg lg:hidden">
            <SidebarContent />
            <div className="mt-auto flex shrink-0 items-center gap-2 px-4 pb-4 pt-3">
              <ServerIP simple />
              <span className="text-[11px] font-semibold text-gray-800">-SolyntekAi-</span>
            </div>
          </aside>
        </Transition>
      </>
    </Transition>
  )
}

export default MobileSidebar